import { CommonModule } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import type { BobToastCardPayload } from "./bob-toast.types";

@Component({
  selector: "app-bob-toast-overlay",
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: "./bob-toast-overlay.component.html",
  styleUrls: ["./bob-toast-overlay.component.scss"],
})
export class BobToastOverlayComponent implements OnInit, OnDestroy {
  @Input({ required: true }) payload!: BobToastCardPayload;
  @Output() dismissed = new EventEmitter<void>();
  @Output() cardClicked = new EventEmitter<void>();

  private dismissTimer?: ReturnType<typeof setTimeout>;
  clickHandled = false;

  ngOnInit(): void {
    if (this.payload.duration > 0) {
      this.dismissTimer = setTimeout(() => this.close(), this.payload.duration);
    }
  }

  ngOnDestroy(): void {
    if (this.dismissTimer) {
      clearTimeout(this.dismissTimer);
    }
  }

  close(): void {
    if (this.dismissTimer) {
      clearTimeout(this.dismissTimer);
      this.dismissTimer = undefined;
    }
    this.dismissed.emit();
  }

  onCardActivate(): void {
    if (!this.payload.clickable || this.clickHandled) {
      return;
    }
    this.emitCardClicked();
  }

  onCardKeydown(event: Event): void {
    if (!this.payload.clickable || this.clickHandled) {
      return;
    }
    const key = (event as KeyboardEvent).key;
    if (key !== "Enter" && key !== " ") {
      return;
    }
    event.preventDefault();
    this.emitCardClicked();
  }

  private emitCardClicked(): void {
    if (this.clickHandled) {
      return;
    }
    this.clickHandled = true;
    this.cardClicked.emit();
  }
}
